module.exports = __webpack_public_path__ + "static/apple-macbook-pro-15-ba1a759e3cfdda7d7abb5f52843e515f.png";